import script from "./OpenMatter.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenMatter.vue?vue&type=script&setup=true&lang=ts"

import "./OpenMatter.vue?vue&type=style&index=0&id=68588ae1&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68588ae1"]])

export default __exports__